export const getAllMaterialService = async () => {
  const URL = `/material`;  
  const query = await fetch(URL)  
  const jsonData = await query.json();  
  return jsonData;
}

export const updateMaterialService = async (id, data) => {
  const URL = `/material/update/${id}`;
  const requestSetup = {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  };
  const query = await fetch(URL, requestSetup);
  const jsonData = await query.json();
  return jsonData;
}

export const createMaterialService = async (data) => {
  const URL = `/material/create`;
  const requestSetup = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  };
  const query = await fetch(URL, requestSetup);
  const jsonData = await query.json();
  return jsonData;
}

export const removeMaterialService = async (id, data) => {
  const URL = `/material/remove/${id}`;
  const requestSetup = {
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  };
  const query = await fetch(URL, requestSetup);
  const jsonData = await query.json();
  return jsonData;
}